import { Component } from '@angular/core';

@Component({
  selector: 'cigna-omni-comm-channel',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss'],
})
export class ContainerComponent {}
